window.addEventListener('UC_UI_INITIALIZED', () => {
    const triggers = document.querySelectorAll('a[href="#cmp-overlay"]');
    triggers && triggers.forEach(trigger => {
        trigger.addEventListener('click', (event) => {
            event.preventDefault()
            UC_UI && UC_UI.showSecondLayer()
        })
    })
})
  